import { useContext, useState } from 'react';
import t from 'react-translate';
import ClickableContainer from 'components/clickable-container';
import { config } from '@config/pendo.config.json';
import useAiRolePlay from '../../hooks/use-ai-role-play';
import AiConversationContext, { Message, Role } from '../context';

type ChatTranscriptViewProps = {
  messages: Message[]
};

const ChatTranscriptView = ({ messages }: ChatTranscriptViewProps) => {
  const {
    aiRolePlayId,
  } = useContext(AiConversationContext);
  const aiRolePlay = useAiRolePlay(aiRolePlayId);
  const { aiCharacterName } = aiRolePlay ?? {};
  const [showTranscript, setShowTranscript] = useState(true);

  return (
    <div>
      <ClickableContainer
        className='text-primary d-flex justify-content-center text-small font-weight-bold mb-3'
        onClick={() => setShowTranscript((prevValue) => !prevValue)}
        data-qa={config.pendo.activities.aiRolePlay.conversationModal.toggleTranscript}
      >
        {showTranscript
          ? t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.HIDE_TRANSCRIPT()
          : t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.SHOW_TRANSCRIPT()}
      </ClickableContainer>
      {showTranscript && (
      <div>
        {messages.map((message) => (
          <div key={message.id} className='d-flex flex-column'>
            <p className='text-regular mb-1 font-weight-bolder'>
              {message.role === Role.LEARNER
                ? t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOU()
                : aiCharacterName}
            </p>
            <p className='mb-4 text-regular'>{message.content}</p>
          </div>
        ))}
      </div>
      )}
    </div>
  );
};

export default ChatTranscriptView;
